/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import UserMenu from '../UserMenu/UserMenu.component';
import OrderDetailsSideNavPropTypes from './OrderDetailsSideNav.component.props';
import orderDetailsSideNavStyles from './OrderDetailsSideNav.component.styles';

/**
 * OrderDetailsSideNavComponent
 * @export
 * @class OrderDetailsSideNavComponent
 * @extends {React.Component<OrderDetailsSideNavComponentComposedProps, OrderDetailsSideNavComponentState>}
 */
export class OrderDetailsSideNavComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderDetailsSideNavComponentProps>}
   * @memberof OrderDetailsSideNavComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderDetailsSideNav`}
   * @memberof OrderDetailsSideNavComponent
   */
  static displayName = `OrderDetailsSideNav`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderDetailsSideNavComponent
   */
  static propTypes = OrderDetailsSideNavPropTypes;

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderDetailsSideNavComponent />`
   * @memberof OrderDetailsSideNavComponent
   */
  render() {
    return <UserMenu showAvatar={false} />;
  }
}

/** @type {React.ComponentClass<OrderDetailsSideNavComponentProps>} */
const OrderDetailsSideNav = compose(withStyles(themeCreateInjectableStyles(orderDetailsSideNavStyles), { withTheme: true }))(OrderDetailsSideNavComponent);

export default OrderDetailsSideNav;
